import { Component, OnInit } from "@angular/core";

import { Observable } from "rxjs";
interface Gateway {
	id: string;
	name: string;
	notificationsEnabled: boolean;
}

interface GatewayGroup {
	id: string;
	groupName: string;
	gateways: Gateway[];
}

@Component({
	selector: "app-new-settings",
	templateUrl: "./new-settings.component.html",
	styleUrl: "./new-settings.component.scss",
	standalone: false,
})
export class NewSettingsComponent implements OnInit {
	groups: GatewayGroup[] = [
		{
			id: "1",
			groupName: "Property A",
			gateways: [
				{ id: "gw1", name: "Gateway A1", notificationsEnabled: true },
				{ id: "gw2", name: "Gateway A2", notificationsEnabled: true },
			],
		},
		{
			id: "2",
			groupName: "Property B",
			gateways: [
				{ id: "gw3", name: "Gateway B1", notificationsEnabled: true },
				{ id: "gw4", name: "Gateway B2", notificationsEnabled: true },
				{ id: "gw5", name: "Gateway B3", notificationsEnabled: true },
			],
		},
	];

	expandedRows = {};

	allNotificationsEnabled: boolean = true;

	first: number = 0;

	rowsPerPageOptions: number[] = [10, 25, 50, 100];
	$filter: Observable<any>;
	constructor() {}

	ngOnInit(): void {}

	toggleGroupNotifications(
		$event: Event,
		group: GatewayGroup,
		value: boolean
	) {
		// $event.preventDefault();
		$event.stopPropagation();
		group.gateways.forEach((gw) => (gw.notificationsEnabled = value));
	}

	getEnabledGatewaysCount(group: any): number {
		return group.gateways.filter(
			(g: Gateway) => g.notificationsEnabled === true
		).length;
	}

	toggleAllNotifications() {
		this.groups.forEach((group) => {
			group.gateways.forEach((gateway) => {
				gateway.notificationsEnabled = this.allNotificationsEnabled;
			});
		});
	}

	expandAll() {
		this.expandedRows = this.groups.reduce(
			(acc, p) => (acc[p.id] = true) && acc,
			{} as any
		);
	}

	collapseAll() {
		this.expandedRows = {};
	}

	onSearchEvent() {}

	onPageChange() {}

	sortChanged() {}

	setFilter() {}

	removeFilter() {}
}
